import { render, staticRenderFns } from "./ToUploadImageCard.vue?vue&type=template&id=1291868d&scoped=true&"
import script from "./ToUploadImageCard.vue?vue&type=script&lang=js&"
export * from "./ToUploadImageCard.vue?vue&type=script&lang=js&"
import style0 from "./ToUploadImageCard.vue?vue&type=style&index=0&id=1291868d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1291868d",
  null
  
)

export default component.exports